import httpClient from '@/apis/httpClient'
import { queryOptions, useQuery } from '@tanstack/react-query'
import qs from 'query-string'

import appConfigs from '../configs/appConfigs'
import {
  DEFAULT_ZMP_SETTING,
  ZMP_SETTING_QUERY_KEY,
} from '../query/zmp-setting'
import type { ZMPConfig } from '../provider/zmp.types'

// Define API response type
interface APIResponse {
  result?: {
    task?: {
      items?: Array<{
        value: string;
      }>;
    };
  };
}

export const fetchZMPSetting = async (): Promise<ZMPConfig> => {
  try {
    const queryString = qs.stringify({
      key: appConfigs.swood_zmp,
    })
    const { data } = await httpClient.get<APIResponse>(
      `/api/v1/Setting/Site?${queryString}`,
    )
    const rawValue = data?.result?.task?.items?.[0]?.value

    if (!rawValue) {
      throw new Error('No settings data found')
    }

    const settings = JSON.parse(rawValue) as ZMPConfig

    return settings
  } catch (error) {
    console.error('Failed to fetch ZMP settings:', error)

    return DEFAULT_ZMP_SETTING
  }
}

export const zmpSettingQueryOptions = queryOptions({
  queryKey: ZMP_SETTING_QUERY_KEY,
  queryFn: fetchZMPSetting,
  staleTime: 5 * 60 * 1000,
})

export const useGetZMPSetting = () => useQuery(zmpSettingQueryOptions)
